import { defineComponent as _defineComponent } from 'vue'
import { LotStatus } from "@/enums/LotStatus";
  import { ExtendedLot } from "@/v2/composables/useLotsData";

  interface Column {
    key: string;
    value: string;
    isSelected: boolean;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'LotsCardView',
  props: {
    lots: {},
    visibleColumns: {},
    editingLot: {},
    editingField: {},
    editingValue: {},
    getFieldType: { type: Function },
    getColumnDisplayValue: { type: Function },
    isFieldEditable: { type: Function },
    isEditing: { type: Function },
    startEdit: { type: Function },
    openStatusModal: { type: Function },
    openEditPriceModal: { type: Function },
    displayStatus: { type: Function },
    getStatusForClass: { type: Function },
    getOfflineDisplayStatus: { type: Function },
    getLotStatusClass: { type: Function },
    canCustomizeColumns: { type: Boolean }
  },
  emits: [
    "updateEditingValue",
    "saveEdit",
    "cancelEdit",
    "toggleCustomizeColumns",
  ],
  setup(__props: any, { expose: __expose }) {
  __expose();

  const props = __props;

  

const __returned__ = { props, get LotStatus() { return LotStatus }, get ExtendedLot() { return ExtendedLot } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})